import { frontendURL } from 'dashboard/helper/URLHelper';

import Login from './login/Index.vue';
export default [
  {
    path: frontendURL('conferences/join/:token'),
    name: 'conference_guest',
    component: () =>
      import('dashboard/components-next/voice/ConferenceGuestLobby.vue'),
    meta: { ignoreSession: true },
    props: true,
  },
  {
    path: frontendURL('login'),
    name: 'login',
    component: Login,
    props: route => ({
      config: route.query.config,
      email: route.query.email,
      ssoAuthToken: route.query.sso_auth_token,
      ssoAccountId: route.query.sso_account_id,
      ssoConversationId: route.query.sso_conversation_id,
      authError: route.query.error,
    }),
  },
  {
    path: frontendURL('login/sso'),
    name: 'sso_login',
    component: () => import('./login/Saml.vue'),
    meta: { requireEnterprise: true },
    props: route => ({
      authError: route.query.error,
      target: route.query.target,
    }),
  },
  {
    path: frontendURL('auth/signup'),
    name: 'auth_signup',
    component: () => import('./auth/signup/Index.vue'),
    meta: { requireSignupEnabled: true },
  },
  {
    path: frontendURL('auth/confirmation'),
    name: 'auth_confirmation',
    component: () => import('./auth/confirmation/Index.vue'),
    meta: { ignoreSession: true },
    props: route => ({
      config: route.query.config,
      confirmationToken: route.query.confirmation_token,
      redirectUrl: route.query.route_url,
    }),
  },
  {
    path: frontendURL('auth/verify-email'),
    name: 'auth_verify_email',
    component: () => import('./auth/verify-email/Index.vue'),
    meta: { ignoreSession: true },
    // From the query, not `window.history.state`: state is wiped by a reload,
    // which used to bounce this page to login.
    props: route => ({
      email: route.query.email || '',
    }),
  },
  {
    path: frontendURL('auth/password/edit'),
    name: 'auth_password_edit',
    component: () => import('./auth/password/Edit.vue'),
    meta: { ignoreSession: true },
    props: route => ({
      config: route.query.config,
      resetPasswordToken: route.query.reset_password_token,
      redirectUrl: route.query.route_url,
    }),
  },
  {
    path: frontendURL('auth/reset/password'),
    name: 'auth_reset_password',
    component: () => import('./auth/reset/password/Index.vue'),
  },
];
